import { z } from 'zod';

export type Session = z.infer<typeof sessionSchema>;
export const sessionSchema = z.object({
  id: z.string(),
  ipAddress: z.string(),
  startedDate: z.string(),
  lastAccessedDate: z.string(),
  expiresAt: z.string(),
  isCurrent: z.boolean(),
});

export type SessionsData = z.infer<typeof sessionsDataSchema>;
export const sessionsDataSchema = z.object({
  sessions: z.array(sessionSchema),
});
